import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Autocomplete, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { formPostData, getData, postData } from 'src/webService/webService';
import { countries } from "country-data";
import Loader from '../Loader/Loader';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import uploadIcon from '../../components/images/upload-placeholder.webp'

const dialCodes = countries.all.map(c => ({
  dialCode: c.countryCallingCodes[0],
}));

const validDialCodes = dialCodes.filter(item => item.dialCode && item.dialCode.trim() !== '').map(item => item.dialCode);

const steps = [
  {
    label: 'Tell Us About Yourself',
    description: 'Add profile details that help buyers know and trust you.',
    fields: [
      {
        type: 'text',
        label: 'Store Name',
        name: 'name',
        required: true,
        size: 6
      },
      {
        type: 'text',
        label: 'GST Number',
        name: 'gst_number',
        required: true,
        size: 6
      },
      {
        type: 'textarea',
        label: 'About your business',
        name: 'aboutus',
        required: true,
        size: 12
      }
    ]
  },
  {
    label: 'Setup Your Brand',
    description: 'Add your first brand',
    fields: [
      {
        type: 'image_upload',
        label: 'Brand Logo',
        name: "brand_logo",
        required: true,
        sie: 12
      },
      {
        type: 'text',
        label: 'Brand Name',
        name: 'brand_name',
        required: true,
        size: 12
      },
      {
        type: 'textarea',
        label: 'Brand Description',
        name: 'brand_description',
        required: true,
        size: 12
      },
      {
        type: 'category_selection',
        size: 12
      },
    ]
  },
  {
    label: 'Add Contact & Location',
    description: 'Make it easy for buyers to reach you — share your location and contact info.',
    fields: [
      {
        type: 'selection',
        label: 'STD Code',
        default: '+91',
        name: 'phone_countrycode',
        options: validDialCodes,
        required: true,
        size: 2
      },
      {
        type: 'text',
        label: 'Mobile Number',
        name: 'phone',
        required: true,
        fieldType: 'number',
        size: 4
      },
      {
        type: 'selection',
        label: 'STD Code',
        default: '+91',
        name: 'whatsapp_countrycode',
        options: validDialCodes,
        required: true,
        size: 2
      },
      {
        type: 'text',
        label: 'Whatsapp Number',
        name: 'whatsapp',
        required: true,
        fieldType: 'number',
        size: 4
      },
      {
        type: 'text',
        label: 'Address',
        name: 'address',
        required: true,
        size: 12
      },
      {
        type: 'text',
        label: 'City',
        name: 'city',
        required: true,
        size: 3
      },
      {
        type: 'text',
        label: 'State',
        name: 'state',
        required: true,
        size: 3
      },
      {
        type: 'text',
        label: 'Country',
        name: 'country',
        required: true,
        size: 3
      },
      {
        type: 'text',
        label: 'Pincode',
        name: 'pincode',
        required: true,
        size: 3
      },
      {
        type: 'text',
        label: 'Map Location',
        name: 'map_location',
        required: false,
        size: 12
      }
    ]
  },
  {
    label: 'Connect Your Socials',
    description: 'Boost your credibility by linking your social media profiles.',
    fields: [
      {
        type: 'text',
        label: 'Instagram Link',
        name: 'instagram_link',
        required: false,
        size: 6
      },
      {
        type: 'text',
        label: 'Facebook Link',
        name: 'facebook_link',
        required: false,
        size: 6
      },
      {
        type: 'text',
        label: 'Twitter Link',
        name: 'twitter_link',
        required: false,
        size: 6
      },
      {
        type: 'text',
        label: 'Website Link',
        name: 'website_link',
        required: false,
        size: 6
      }
    ]
  },
  {
    label: 'Complete Final Step',
    description: 'Set your login password',
    fields: [
      {
        type: 'text',
        label: 'User Name',
        name: 'username',
        required: true,
        size: 4
      },
      {
        type: 'text',
        label: 'Password',
        name: 'password',
        required: true,
        fieldType: 'password',
        size: 4
      },
      {
        type: 'text',
        label: 'Confirm Password',
        name: 'confirm_password',
        fieldType: 'password',
        required: true,
        size: 4
      }
    ]
  }
];

export default function RegistrationStepperForm() {
  const { token } = useParams();
  const [isRegisterCompleted, setIsRegisterCompleted] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [triggerLoading, setTriggerLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [categories, setCategories] = useState([]);
  const [categoriesArray, setCategoriesArray] = useState([]);
  const initialImage = uploadIcon;
  const [preview, setPreview] = useState(initialImage);

  useEffect(() => {
    getData('auth/seller/categories', { all: 1, withChildren: 1 }, null).then((res) => {
      if (res.status === 200) {
        setCategoriesArray(res.data);
      }
      setTriggerLoading(false);
    })
  }, []);

  useEffect(() => {
    if (errorMessage == null) return;
    setTimeout(() => {
      setErrorMessage(null);
    }, 5000);
  }, [errorMessage]);

  const handleNext = () => {
    setTriggerLoading(true);
    var isError = false;
    if (activeStep == 1) {
      const fieldSet = steps[activeStep].fields;
      const invalidFields = fieldSet
        .filter((field) => field.required && !formValues[field.name])
        .map((field) => field.label || field.name);
      if (invalidFields.length > 0 || categories.length == 0) {
        setErrorMessage("Required fields: " + invalidFields.join(', ') + ((categories.length == 0) ? ",Categories" : ""));
        isError = true;
      }
      // if (categories.length == 0) {
      //   setErrorMessage("Choose any categories");
      //   isError = true;
      // }
    } else {
      if (steps[activeStep].fields.length > 0) {
        const fieldSet = steps[activeStep].fields;
        const invalidFields = fieldSet
          .filter((field) => field.required && !formValues[field.name])
          .map((field) => field.label || field.name);
        if (invalidFields.length > 0) {
          setErrorMessage("Required fields: " + invalidFields.join(', '));
          isError = true;
        }

        if (activeStep == steps.length - 1) {
          if (formValues['password'] == null || formValues['confirm_password'] == null) {
            setErrorMessage("Password & Confirm Password are required");
            isError = true;
          } else if (formValues['password'] != formValues['confirm_password']) {
            setErrorMessage("Password & Confirm Password must be same");
            isError = true;
          }

          if (!isError) {

            const data = {
              ...formValues,
              category: JSON.stringify(categories),
            };

            const formDataToSend = new FormData();

            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                formDataToSend.append(key, data[key]);
              }
            }

            console.log(data, 'Form Values');
            console.log(formDataToSend, 'Form Values');
            formPostData("auth/seller/onboard/invite/" + token, formDataToSend, null).then((res) => {
              // setTriggerLoading(true)
              if (res.status === 201 && res.requestStatus == true) {
                toast.success(res.message);
                setIsRegisterCompleted(true);
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setErrorMessage(null);
              } else {
                setActiveStep(res?.failedStep ? res.failedStep - 1 : 0);
                toast.error(res.message);
                setErrorMessage(`Error: ${res?.failedField || ""}`);
              }
            });
          }
        }
      }
    }
    if (!isError && activeStep !== steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setErrorMessage(null);
    }
    setTriggerLoading(false);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCategoryChange = (event, newValue) => {
    const selectedIds = newValue.map((item) => item._id);
    setCategories(selectedIds);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setFormValues((prev) => ({
        ...prev,
        ['brand_logo']: file,
      }));
    }
  };

  const renderField = (field) => {
    const handleChange = (fieldName, fieldValue) => {
      setFormValues((prev) => ({
        ...prev,
        [fieldName]: fieldValue,
      }));
    };

    if (field.default) {
      formValues[field.name] = field.default;
    }

    switch (field.type) {
      case 'text':
        return (
          <Grid item xs={12} md={field.size ?? 12}>
            <TextField
              type={field.fieldType ? field.fieldType : "text"}
              key={field.name}
              label={field.label + (field.required ? " *" : "")}
              name={field.name}
              fullWidth
              margin="normal"
              value={formValues[field.name] || ''}
              onChange={(event, newValue) => handleChange(field.name, event.target.value)}
            />
          </Grid>
        );
      case 'textarea':
        return (
          <Grid item  xs={12} md={field.size ?? 12}>
            <TextField
              key={field.name}
              label={field.label + (field.required ? " *" : "")}
              name={field.name}
              multiline
              rows={2}
              fullWidth
              margin="normal"
              value={formValues[field.name] || ''}
              onChange={(event, newValue) => handleChange(field.name, event.target.value)}
            />
          </Grid>
        );
      case 'selection':
        return (
          <Grid item  xs={12} md={field.size ?? 12}>
            <Autocomplete
              key={field.name}
              name={field.name}
              style={{ marginTop: '16px' }}
              fullWidth
              margin="normal"
              options={field.options}
              value={formValues[field.name] || ''}
              onChange={(event, newValue) => handleChange(field.name, newValue)}
              renderInput={(params) => <TextField {...params} label={field.label} />}
            />
          </Grid>
        );
      case 'category_selection':
        return (
          <Grid item  xs={12} md={field.size ?? 12}>
            <Autocomplete
              style={{ marginTop: '10px' }}
              multiple
              options={(categoriesArray || []).filter((cat) => cat.subCategoryCount === 0)}
              groupBy={(option) => {
                const parent = categoriesArray.find(
                  (parentCat) => parentCat._id == option.parent
                );
                return parent?.name || 'Uncategoriezed';
              }}
              getOptionLabel={(option) => ((option.parent != null) ? "" : "") + `${option.name}`}
              value={categoriesArray.filter((item) => categories.includes(item._id))}
              onChange={handleCategoryChange}
              renderInput={(params) => (
                <TextField {...params} label="Category *" variant="outlined" />
              )}
              renderGroup={(params) => (
                <div key={params.key}>
                  <Typography sx={{ mt: 0, mb: 0, fontWeight: 'bold', px: 2, background: '#dbdee2' }}>
                    {params.group}
                  </Typography>
                  {params.children}
                </div>
              )}
            />
          </Grid>
        );
      case 'image_upload':
        return (
          <Grid item  xs={12} md={12}>
            <Grid item xs={field.size ?? 6} sx={{ margin: "0 auto" }}>
              <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                <input
                  type="file"
                  accept="image/*"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
                <label htmlFor="fileInput">
                  <img
                    src={preview}
                    alt="Uploaded"
                    style={{
                      width: "150px",
                      height: "115px",
                      objectFit: "contain",
                      cursor: "pointer",
                      borderRadius: "10px",
                    }}
                  />
                  <p className='mb-0' style={{ fontSize: '12px' }}>Upload Brand Logo</p>
                </label>
              </div>
            </Grid>
          </Grid>
        )
      default:
        return null;
    }
  };
  return (
    <Box id={'OnboardForm'} sx={{ width: 800 }} className={'align-items-center position-relative'}>
      {triggerLoading ? <div className='position-absolute' style={{ top: 0, left: 0, right: 0, bottom: 0, zIndex: 100 }}><Loader absolute='true' /></div> : <></>}
      {!isRegisterCompleted ? <>
        <Typography sx={{ mb: 3 }} variant='h4' className='text-center'>Complete your profile</Typography>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel>
                <Typography sx={{ mb: 0 }} variant="h6" gutterBottom>{step.label}</Typography>
              </StepLabel>
              <StepContent>
                <Typography>{step.description}</Typography>

                <Box sx={{ my: 2 }}>
                  <Grid container spacing={1}>
                    {step.fields?.map((field) => renderField(field))}
                  </Grid>
                </Box>

                <Box sx={{ mb: 2 }}>
                  {index != 0 && <Button
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    Back
                  </Button>}
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    {index === steps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                  {errorMessage != null && <Typography color={'error'} className='d-inline'>{errorMessage}</Typography>}
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </> :
        <>
          <div className='text-center'>
            <Typography sx={{ mb: 3 }} variant='h4'>Profile registration completed successfully</Typography>
            <p>Kindly proceed to login to your account </p>
            <Button component={Link} to="/seller/login" className="webButton" sx={{ color: 'white' }}>LOGIN</Button>
          </div>
        </>}
    </Box>
  );
}